import { CraftTemplateType } from '@core-mkt/craft/craft-template-types';
import { CraftQuery } from '@core-mkt/craft/craft-query';
import { TemplateSingleQuery } from '../templates/single-template/template-component/template-single-query';

export const SingleTemplateCraftQueries = new Map<CraftTemplateType, CraftQuery>([
  ['visionTemplateEntry', TemplateSingleQuery],
]);
